import { ConfigService } from '@services/webFeeder/config.service';
import { NotificationsService } from 'angular2-notifications';
import { Constants } from '@utils/constants';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AuthServer } from '@services/auth-server.service';
import { ModalSignatureComponent } from '@component/modal-signature/modal-signature.component';

@Component({
  selector: 'app-eletronic-signature-modal',
  templateUrl: './eletronic-signature-modal.component.html'
})
export class EletronicSignatureModalComponent implements OnInit {

  title = 'Confirme sua operação';
  confirmText = 'Confirmar';
  eletronicSignatureTypes = Constants.ELETRONIC_SIGNATURE_TYPES;
  selectedEletronicSignatureType: any = null;
  eletronicSignature: any;
  componentError = false;
  loading = true;
  loadingComponent = true;
  maxChar = 0;
  validSignature: boolean;
  saveSignature: boolean;
  dialog: MatDialog;

  constructor(
    public dialogRef: MatDialogRef<EletronicSignatureModalComponent>,
    private notificationService: NotificationsService,
    private cd: ChangeDetectorRef,
    private _configService: ConfigService,
    private _authServer: AuthServer,
    dialog: MatDialog
  ) {
    this.dialog = dialog;
    const eletronicSignaturetemp = this._configService.getEletronicSignatureType();
    if (eletronicSignaturetemp && eletronicSignaturetemp.isActive) {
      this.selectedEletronicSignatureType = eletronicSignaturetemp.type;
    }
    switch (this.selectedEletronicSignatureType) {
      case Constants.ELETRONIC_SIGNATURE_TYPES.virtual_keyboard:
        this.maxChar = 5;
        break;
      case Constants.ELETRONIC_SIGNATURE_TYPES.string:
        this.maxChar = 6;
        break;
      default:
        break;
    }
  }


  ngOnInit() {
    if (!this.selectedEletronicSignatureType) {
      this.notificationService.error('Atenção', 'Falha ao buscar informações sobre assinatura eletronica, por favor tente novamente.');
      this.dialogRef.close(false);
    } else {
      this.loading = false;
    }
  }

  onKeyChange(signature) {
    this.eletronicSignature = signature;
  }

  onComponentReady(ready) {
    if (ready) {
      this.loadingComponent = false;
      this.cd.detectChanges();
    }
  }

  onComponentError(error) {
    if (error) {
      this.componentError = true;
    }
  }

  close() {
    this.dialogRef.close(false);
  }

  confirm() {
    if (this.eletronicSignature && this.eletronicSignature.keys && this.eletronicSignature.keys.length === this.maxChar &&
      ((this.selectedEletronicSignatureType === Constants.ELETRONIC_SIGNATURE_TYPES.virtual_keyboard && this.eletronicSignature.hashTeclado)
        || (this.selectedEletronicSignatureType === Constants.ELETRONIC_SIGNATURE_TYPES.string))
    ) {
      this.loading = true;
      let params;
      if (this.selectedEletronicSignatureType === Constants.ELETRONIC_SIGNATURE_TYPES.string) {
        const clientId = Number(this._configService.getHbAccountId());
        params = { user_client_id: clientId, signature: this.eletronicSignature.keys };
      } else {
        params = this.eletronicSignature;
      }
      this._authServer.iEletronicSignature.validateSignature(params)
        .subscribe(res => {
          if (this.selectedEletronicSignatureType === Constants.ELETRONIC_SIGNATURE_TYPES.virtual_keyboard) {
            if (res && res.IsResponseOk && res.SerializedObject && JSON.parse(res.SerializedObject).Autenticado) {
              this.validSignature = true;
              params.validSignature = true;
              this.dialogRef.close(params);
              this.fullSignatureFlag();
            } else if (res && res.IsResponseOk && res.SerializedObject && !JSON.parse(res.SerializedObject).Autenticado) {
              this.notificationService.error('', 'Código de segurança inválido!');
              this._configService.deleteHbSignature();
              this.validSignature = false;
              this.saveSignature = false;
              this.eletronicSignature.keys = [];
              this.loading = false;
            } else if (res && !res.IsResponseOk && res.ErrorMessage.length > 0) {
              res.ErrorMessage.forEach(element => {
                this.notificationService.error('', element);
              });
              this.eletronicSignature.keys = [];
              this.dialogRef.close(false);
            }
          } else {
            if (res && res._isScalar !== false && res.is_valid) {
              this.validSignature = true;
              this.fullSignatureFlag();
              params.validSignature = true;
              params.saveSignature = this.saveSignature;
              this.dialogRef.close(params);
            } else {
              this.notificationService.error('', 'Código de segurança inválido!');
              this._configService.deleteHbSignature();
              this.validSignature = false;
              this.saveSignature = false;
              this.eletronicSignature.keys = [];
              this.loading = false;
            }
          }
        }, () => {
          this.notificationService.error('', 'Ocorreu um erro ao validar a Código de segurança!');
          this._configService.deleteHbSignature();
          this.validSignature = false;
          this.eletronicSignature.keys = [];
          this.loading = false;
          this.saveSignature = false;
        });
    }
  }

  forgot() {
    this._authServer.iEletronicSignature.forgotPassword()
      .subscribe(res => {
        if (res && (!res.error || res.error === 'false')) {
          this.notificationService.success('', 'Solicitação de recuperação do Código de Segurança enviado por e-mail.');
        } else {
          this.notificationService.error('', 'Ocorreu um erro na solicitação de recuperação do Código de Segurança.');
        }
      }, error => {
        const message = error && error.message ? error.message : 'Ocorreu um erro na solicitação de recuperação do Código de Segurança.';
        this.notificationService.error('', message);
      });
  }

  fullSignatureFlag() {
    if (!this.saveSignature && this._configService.getHbSignature()) {
      this.saveSignature = false;
      this._configService.deleteHbSignature();
      this.notificationService.error('', 'Código de segurança removido na sessão.');
    } else if (this.saveSignature) {
      let eletronicSignature;
      if (this.selectedEletronicSignatureType === Constants.ELETRONIC_SIGNATURE_TYPES.virtual_keyboard) {
        eletronicSignature = this.eletronicSignature;
      } else {
        eletronicSignature = this.eletronicSignature.keys;
      }
      this._configService.setHbSignature(eletronicSignature);
      this.notificationService.success('', 'Código de segurança salvo na sessão.');
    }
  }
}
